<template>
  <!-- 天美贷我要还款页面 -->
  <div class="page tmd-repayment">
    <navigation class="navigation">我要还款</navigation>

    <div class="wapper">
      <div class="repayment-info" :class="{ 'overdue': isOverDue()}">
        <div class="card-description" :class="{ 'overdue': isOverDue() }">
          <span>{{ descriptionText }}</span>
        </div>

        <div class="card-amount" :class="{ 'overdue': isOverDue() }">
          {{ totalRepaymentAmount | currency }}
        </div>
      </div>
    </div>

    <div class="repayment-schedule">
      <div class="cell-title">
        <img src="./images/repayment_detail.png" />
        <span>明细</span>
      </div>
      <div class="term-list">
        <div class="term-item" v-for="(item, index) in scheduleList" :key="index">
          <div class="repay-time">
            {{ creditStartTime | date }}
          </div>
          <div class="content">
            <div class="platform">
              {{ platform(loanPlatform).name }} {{ item.repaymentIndex }}/{{ totalTermNo }} 期
            </div>
            <div class="amount">
              ￥{{ item.repaymentDueTotal | currency }}
            </div>
          </div>
          <div class="info">
            <img src="./images/info.png" @click.stop="overdueRepaymentInfo(item)">
          </div>
        </div> 
      </div>
    </div>

    <div class="footer">
      <nd-button class="btn" :loading='this.offLineRepayInProcess || this.onLineRepayInProcess' @click="goRepayment" :disabled="!canRepay">{{ repayBtnText }}</nd-button>
    </div>

    <!-- 逾期还款说明 -->
    <nd-dialog v-model="overdueVisible" :footer="false" closeBtn>
      <div class="overdue-repayemnt-info">
        <div class="title">明细说明</div>

        <div class="divide">
          {{ creditStartTime | date('YYYY/MM/DD') }} 借款分期 {{ popItem.repaymentIndex }}/{{ totalTermNo }}
        </div>

        <div class="amount" :class="{ 'overdue': popItem.termStatus === 'O' }">
          ¥{{ (popItem.repaymentDueTotal - popItem.wavInt ) | currency }}<em v-if="popItem.hasWav">¥{{ popItem.repaymentDueTotal | currency }}</em>
        </div>

        <div class="explain" v-if="popItem.hasWav">
          <span>减免时效：于{{ popItem.wavDateTime | date('YYYY/MM/DD') }}前还款享受逾期减免</span>
        </div>

        <div class="principal">
          <span>本金(元)</span> {{ popItem.schdPrin | currency }}
        </div>

        <div class="interest">
          <span>利息(元)</span> {{ popItem.schdInt | currency }}
        </div>

        <div class="interest" v-if="popItem.fee">
          <span>服务费(元)</span> {{ popItem.fee | currency }}
        </div>

        <div class="interest" v-if="popItem.intDelay">
          <span>违约金(元)</span> {{ popItem.intDelay | currency }}
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'tmd-repayment',
  data: function () {
    return {
      query: this.$route.query || {},
      orderId: this.$route.query.orderId,
      totalRepaymentAmount: 0.00,
      creditStartTime: Date.now(),
      loanPlatform: this.$route.query.loanPlatform,
      agreementUrl: '',
      fundCode: 'WUJIE',
      productCd: this.$route.query.productCd,
      fundPartnerCd: this.$route.query.fundPartnerCd,
      scheduleList: [],
      canRepay: true,
      canOffLineRepay: false,
      onLineRepayInProcess: false, // 当前订单是否在线上还款中（true 线上还款中）
      offLineRepayInProcess: false, // 当前订单是否在处于线上还款中（true 线下还款中）
      dueDate: '',
      canRepayDate: '',
      termNo: '',
      popItem: {}, 
      overdueVisible: false,
      totalTermNo: 0,
      displayList: [], // 所有展示的还款计划
      canRepayList: [], // 所有可选期
      overdueList: [] // 所有逾期
    }
  }, 
  async created () {
    await this.getOrderDetail()
    this.$bus.$emit('ready')
    this.$statistics('REPAY')
  },
  filters: {
    status (value) {
      const mapping = {
        U: '待还',
        O: '已逾期',
        S: '已还',
        J: '还款中',
        R: '对账中'
      }
      return mapping[value]
    }
  },

  watch: {
    overdueVisible (value) {
      if (value) {
        this.$report({
          id: 10100,
          args: {
            visible: 1
          }
        })
      } else {
        this.$report({
          id: 10100,
          args: {
            visible: 0
          }
        })
      }
    }
  },
        
  methods: {
    ...mapActions('order', ['getOrderDetailX']),
    ...mapActions('repay', ['getRepayTrialX']),

    getRepayTrial () {
      const params = {
        loanPlatform: this.loanPlatform,
        orderId: this.orderId,
        terms: this.scheduleList.map(item => {
          return {
            termNo: item.repaymentIndex,
            overdays: item.overdueDays
          }
        }),
        fundCode: this.fundCode
      }
      return this.getRepayTrialX(params)
    },

    // 查看逾期还款详情
    overdueRepaymentInfo (item) {
      this.$report({
        id: 10099
      })
      this.popItem = item
      this.overdueVisible = true
    },

    async goRepayment () {
      this.$report({
        id: 10098
      })

      // 如果有多期逾期
      if (this.overdueList.length > 1 && this.fundCode !== 'CEF') {
        this.$router.push({
          path: '/repayment/overdue',
          query: this.query, 
          orderId: this.orderId
        })
      } else {
        this.$storage.set(
          'selectedTerms',
          this.scheduleList
        )
        const response = await this.getRepayTrial()
        if (response.success) {
          this.$storage.set('trail', response.data)
          this.$router.push({
            path: '/repayment/confirm/tmd',
            query: {
              orderId: this.orderId,
              loanPlatform: this.loanPlatform,
              fundCode: this.fundCode, 
              productCd: this.productCd, 
              canOffLineRepay: this.canOffLineRepay ? 'T' : 'F'
            }
          })
        }
      }
    },

    async getOrderDetail () {
      const response = await this.getOrderDetailX(this.query)
      if (response.success === true) {
        this.creditStartTime = response.data.creditStartTime
        this.loanPlatform = response.data.loanPlatform
        this.agreementUrl = response.data.agreementUrl
        this.fundCode = response.data.fundCode
        this.scheduleList = response.data.terms
        this.canRepay = response.data.canRepay
        this.offLineRepayInProcess = response.data.offLineRepayInProcess
        this.onLineRepayInProcess = response.data.onLineRepayInProcess
        this.dueDate = response.data.dueDate
        this.canRepayDate = response.data.canRepayDate
        this.termNo = response.data.termNo
        this.orderId = response.data.orderId
        this.canOffLineRepay = response.data.canOffLineRepay
        this.totalTermNo = response.data.totalTermNo
                    
        // 默认选择逾期期数
        this.overdueList = this.scheduleList.filter(item => item.termStatus === 'O')
        this.canRepayList = this.scheduleList.filter(item => item.termCanRepay)
        if (this.overdueList.length > 0) { // 如果有逾期 展示逾期
          this.scheduleList = this.overdueList
          if (this.fundCode === 'CEF') {
            const currentTerms = this.canRepayList.filter(item => item.repaymentIndex === this.termNo && item.termCanRepay)
            if (currentTerms[0] && currentTerms[0].termStatus && currentTerms[0].termStatus !== 'O') {
              this.scheduleList.push(currentTerms[0])
            }
          }

          this.$report({
            id: 10097,
            args: {
              status: 0
            }
          })
        } else { 
          // 找到当前期
          const currentTerms = this.scheduleList.filter(item => item.repaymentIndex === this.termNo)
          if (currentTerms && currentTerms.length > 0) { // 如果没有逾期，这块是只展示当前期，如果当前期已还，展示下一期
            const currentTerm = currentTerms[0]
            if (currentTerm.termStatus === 'S') { // 当期已还
              // 是否是最后
              if (this.termNo >= this.scheduleList[this.scheduleList.length - 1].repaymentIndex) { // 已经是最后一期了 没有下一期
                this.scheduleList = []
              } else { // 展示下一期
                this.scheduleList = this.scheduleList.filter(item => item.repaymentIndex === (this.termNo + 1))
              }
            } else {
              this.scheduleList = [currentTerm]
            }
          }

          if (this.canRepay) {
            this.$report({
              id: 10097,
              args: {
                status: 1
              }
            })
          } else {
            this.$report({
              id: 10097,
              args: {
                status: 2
              }
            })
          }
        }

        // 计算当前还款金额
        this.totalRepaymentAmount = this.scheduleList.reduce((a, b) => a + b.repaymentDueTotal, 0)
      }
    },

    platform (type) {
      const map = {
        'YZD': {
          name: '聚美颜值贷' 
        }, 
        'LFQ': {
          name: '领分期' 
        },
        'TMD': {
          name: '天美贷'
        }
      }
      return map[type]
    },

    isOverDue () {
      return this.overdueList.length > 0
    }
  },

  computed: {
    descriptionText () {
      if (this.isOverDue()) {
        return '逾期应还(元)'
      } else {
        return this.formatDate(this.dueDate, 'M月D日应还 (元)')
      } 
    },

    repayBtnText () {
      if (this.canRepay) {
        return '去还款'
      } else {
        if (this.onLineRepayInProcess && !this.offLineRepayInProcess) { // 线上还款中
          return '还款受理中'
        }
        if (this.offLineRepayInProcess && !this.onLineRepayInProcess) { // 线下还款中
          return '还款受理中'
        } else {
          return this.formatDate(this.canRepayDate, 'M月D日可还款')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    .tmd-repayment {
        background-color: #fafafa;
        padding-bottom: 210px;
        .navigation {
            border-bottom: 2px #fafafa solid;
        }
        .wapper {
            background: #ffffff;
            padding-bottom: 46px;
            padding-top: 10px;
            margin: 0 auto;
            .repayment-info {
                &.overdue {
                    background: rgba(255, 51, 51, 0.03)
                }
                margin: 30px 40px 90px 40px;
                padding: 40px 30px;
                border-radius: 20px;
                box-sizing: border-box;
                
                .card-description {
                    font-size: 26px;
                    height: 40px;
                    line-height: 40px;
                    margin-top: 20px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: @fc2;
                    text-align: center;
                    &.overdue {
                        color: #333333;
                    }
                }

                .card-amount {
                    height: 67px;
                    line-height: 67px;
                    font-size: 72px;
                    margin-top: 5px;
                    font-family: DIN-Medium,DIN;
                    font-weight: 500;
                    text-align: center;
                    color: #333333;
                    &.overdue {
                        color: #FF3446;
                    }
                }
            }
        }
        

        .repayment-schedule {
            background: #ffffff;
            .cell-title {
                font-size: 32px;
                padding-bottom: 30px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
                img {
                    position: relative;
                    top: 50%;
                    transform: translateY(10%);
                    margin-left: 40px;
                    width: 24px;
                    height: 29px;
                }
            }
            .term-list {
                .term-item {
                    background-color: #FFFFFF;
                    border: 1.5px #fafafa solid;
                    font-size:28px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                    display: flex;
                    justify-content: space-between;
                    padding: 35px 40px;
                    .content {
                        margin-left: -200px;
                    }
                    .info {
                        width: 23px;
                        height: 23px;
                        margin-top: 40px;
                        margin-right: 20px;
                        >img {
                            display: block;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
        .footer {
            width: 750px;
            margin-left: -375px;
            height: 180px;
            background-color: #FFF;
            position: fixed;
            bottom: 0;
            left: 50%;

            .btn {
                margin: 0 auto;
                margin-top: 28px;
            }
        }

        .overdue-repayemnt-info, .prepay-rule {
            padding: 0 45px;
            padding-bottom: 37px;

            .title {
                height: 72px;
                line-height: 72px;
                font-size: 42px;
                font-family: PingFangSC-Semibold,PingFang SC;
                font-weight: 600;
            }

            .divide {
                height: 32px;
                line-height: 32px;
                font-size: 28px;
                margin-top: 23px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
            }

            .amount {
                font-size: 32px;
                height: 32px;
                line-height: 32px;
                margin-top: 27px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                color: @fc1;

                &.overdue {
                    color: @theme;
                }

                em {
                    font-size: 22px;
                    padding-left: 10px;
                    display: inline-block;
                    font-style: normal;
                    font-family: PingFangSC-Medium,PingFang SC;
                    font-weight: 500;
                    color: @fc4;
                    text-decoration: line-through;
                }
            }

            .explain {
                font-size: 22px;
                height: 44px;
                line-height: 44px;
                margin-top: 3px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc4;
                text-align: left;
            }

            .principal,.interest {
                margin-top: 15px;
                height: 40px;
                line-height: 40px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                span {
                    display: inline-block;
                    width: 180px;
                }
            }

            p {
                font-size: 24px;
                line-height: 33px;
                margin-top: 30px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
            }
        }
    }
</style>